import React from 'react'
import { motion } from 'framer-motion';

const CTA = () => {
    const textVariants = {
        hidden: {
          opacity: 0,
          y: 20,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.5,
          },
        },
      };
    
      const containerVariants = {
        visible: {
          transition: {
            staggerChildren: 0.1, // Adjust the stagger duration as needed
          },
        },
      };
    
  return (
    <div className=' mx-auto md:flex items-center justify-center p-4 lg:px-8 text-white mt-24'>
        <div className=" max-w-7xl">
        <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="text-center"
    >
      <motion.h1
        variants={textVariants}
        className="cta-text md:text-[120px] md:leading-[104px] text-[55px] leading-[60px] mb-10 "
      >
        HAVE A COOL PROJECT?
      </motion.h1>
    </motion.div>
         <div className="flex justify-center items-center">
         <a href="#home" className=' cta-button  px-6 py-4  text-black bg-white rounded-full'>
            Let's Talk
          </a>
         </div>
        </div>
    </div>
  )
}

export default CTA